import { template as _$template } from "solid-js/web";
import { memo as _$memo } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<p class="world-viewer__status world-viewer__status--error">Failed to load region: `),
  _tmpl$2 = /*#__PURE__*/_$template(`<p class=world-viewer__status>Loading region…`),
  _tmpl$3 = /*#__PURE__*/_$template(`<div class=world-viewer><div class=world-viewer__panes>`),
  _tmpl$4 = /*#__PURE__*/_$template(`<p class=world-viewer__selection>Selected: <!> — objectId <!>, x=<!>, y=<!>, <!>°`);
import { createMemo, createResource, Show } from "solid-js";
import { loadWorldRegion } from "../../world/region-loader.ts";
import { WorldMapPane } from "../world-map-pane.tsx";
import { WorldThreePane } from "../world-three-pane.tsx";
import { useWorldSelection } from "../world-selection.ts";

/**
 * `/assets` World category viewer: a 2D map (canvas, pan/zoom, placements
 * coloured by object type + approximate aerodrome markers, `world-map-pane.tsx`)
 * alongside a 3D preview of the same region (the shared WebGPU instancing
 * infra, `three/world-instancer.ts` — one `InstancedMesh` per distinct
 * object, same as `/fly`, `world-three-pane.tsx`). Selecting a placement on
 * the map focuses it in the 3D pane when WebGPU is available; the map
 * itself works either way, since it never touches WebGPU. Split across
 * three small files (this router + the two panes) to keep each component
 * short — see `world-selection.ts` for the signal the two panes share.
 */
export function WorldViewer(props) {
  const [regionData] = createResource(() => props.entry.path, loadWorldRegion);
  const selection = useWorldSelection(() => props.entry.path);
  const selectedPlacement = createMemo(() => {
    const region = regionData();
    const index = selection.selectedIndex();
    return region && index !== undefined ? region.placements[index] : undefined;
  });
  return (() => {
    var _el$ = _tmpl$3(),
      _el$5 = _el$.firstChild;
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return regionData.error;
      },
      get children() {
        var _el$2 = _tmpl$(),
          _el$3 = _el$2.firstChild;
        _$insert(_el$2, () => String(regionData.error), null);
        return _el$2;
      }
    }), _el$5);
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return regionData.loading;
      },
      get children() {
        return _tmpl$2();
      }
    }), _el$5);
    _$insert(_el$5, _$createComponent(WorldMapPane, {
      get region() {
        return regionData();
      },
      get selectedIndex() {
        return selection.selectedIndex();
      },
      get onSelect() {
        return selection.setSelectedIndex;
      }
    }), null);
    _$insert(_el$5, _$createComponent(WorldThreePane, {
      get region() {
        return regionData();
      },
      get selectedPlacement() {
        return selectedPlacement();
      }
    }), null);
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return selectedPlacement();
      },
      children: placement => (() => {
        var _el$6 = _tmpl$4(),
          _el$7 = _el$6.firstChild,
          _el$12 = _el$7.nextSibling,
          _el$8 = _el$12.nextSibling,
          _el$13 = _el$8.nextSibling,
          _el$9 = _el$13.nextSibling,
          _el$14 = _el$9.nextSibling,
          _el$0 = _el$14.nextSibling,
          _el$15 = _el$0.nextSibling,
          _el$1 = _el$15.nextSibling,
          _el$16 = _el$1.nextSibling,
          _el$11 = _el$16.nextSibling;
        _$insert(_el$6, () => placement().objectRef ?? "(unresolved slot)", _el$12);
        _$insert(_el$6, () => placement().objectId, _el$13);
        _$insert(_el$6, () => placement().x, _el$14);
        _$insert(_el$6, () => placement().y, _el$15);
        _$insert(_el$6, () => placement().rotationDegrees.toFixed(1), _el$16);
        return _el$6;
      })()
    }), null);
    return _el$;
  })();
}